import { render, staticRenderFns } from "./ConfirmUpdate.vue?vue&type=template&id=b13d90ee&scoped=true"
import script from "./ConfirmUpdate.vue?vue&type=script&lang=js"
export * from "./ConfirmUpdate.vue?vue&type=script&lang=js"
import style0 from "./ConfirmUpdate.vue?vue&type=style&index=0&id=b13d90ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13d90ee",
  null
  
)

export default component.exports